/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlClientRoles } from './ControlClientRoles';
import {
    ControlClientRolesFromJSON,
    ControlClientRolesFromJSONTyped,
    ControlClientRolesToJSON,
} from './ControlClientRoles';
import type { ControlContactTypeAssignment } from './ControlContactTypeAssignment';
import {
    ControlContactTypeAssignmentFromJSON,
    ControlContactTypeAssignmentFromJSONTyped,
    ControlContactTypeAssignmentToJSON,
} from './ControlContactTypeAssignment';

/**
 * 
 * @export
 * @interface ControlAdminAddOrUpdateEntityContactRequest
 */
export interface ControlAdminAddOrUpdateEntityContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlAdminAddOrUpdateEntityContactRequest
     */
    email: string;
    /**
     * 
     * @type {ControlClientRoles}
     * @memberof ControlAdminAddOrUpdateEntityContactRequest
     */
    client_role: ControlClientRoles;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminAddOrUpdateEntityContactRequest
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminAddOrUpdateEntityContactRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminAddOrUpdateEntityContactRequest
     */
    cadency?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminAddOrUpdateEntityContactRequest
     */
    phone?: string;
    /**
     * 
     * @type {ControlContactTypeAssignment}
     * @memberof ControlAdminAddOrUpdateEntityContactRequest
     */
    contact_type_assignment?: ControlContactTypeAssignment;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAdminAddOrUpdateEntityContactRequest
     */
    disabled?: boolean;
}

/**
 * Check if a given object implements the ControlAdminAddOrUpdateEntityContactRequest interface.
 */
export function instanceOfControlAdminAddOrUpdateEntityContactRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "client_role" in value;
    isInstance = isInstance && "client_id" in value;

    return isInstance;
}

export function ControlAdminAddOrUpdateEntityContactRequestFromJSON(json: any): ControlAdminAddOrUpdateEntityContactRequest {
    return ControlAdminAddOrUpdateEntityContactRequestFromJSONTyped(json, false);
}

export function ControlAdminAddOrUpdateEntityContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAdminAddOrUpdateEntityContactRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'client_role': ControlClientRolesFromJSON(json['client_role']),
        'client_id': json['client_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'cadency': !exists(json, 'cadency') ? undefined : json['cadency'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'contact_type_assignment': !exists(json, 'contact_type_assignment') ? undefined : ControlContactTypeAssignmentFromJSON(json['contact_type_assignment']),
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function ControlAdminAddOrUpdateEntityContactRequestToJSON(value?: ControlAdminAddOrUpdateEntityContactRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'client_role': ControlClientRolesToJSON(value.client_role),
        'client_id': value.client_id,
        'name': value.name,
        'cadency': value.cadency,
        'phone': value.phone,
        'contact_type_assignment': ControlContactTypeAssignmentToJSON(value.contact_type_assignment),
        'disabled': value.disabled,
    };
}

